import React, { Component } from "react";
import AdminNavbar from "../../../components/Admin/adminNavbar";
import AddSectionForm from "./addSectionForm";
import { connect } from "react-redux";
import AuthAdmin from "../../../components/AuthAdmin/AuthAdmin";
import Spinner from "../../../components/Spinner/Spinner";

class WorkoutPlans extends Component {
  state = {};
  render() {
    let { isAuthenticated, admin, staff, userId } = this.props;
    if (localStorage.getItem("idToken")) {
      if (userId == null && admin == null && staff == null) {
        return <Spinner />;
      }
    }

    if (!isAuthenticated || !(admin || staff)) {
      return <AuthAdmin />;
    }
    return (
      <React.Fragment>
        <AdminNavbar />
        <AddSectionForm />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.userId != null,
    admin: state.auth.admin,
    staff: state.auth.staff,
    userId: state.auth.userId,
  };
};

export default connect(mapStateToProps, null)(WorkoutPlans);
